module.exports = __webpack_public_path__ + "f74ad641451f59b0b5c30b3ba789d27b.png";